qw-basket {
  display: flex;
  justify-content: space-between;
}

.qw-basket__price {
  display: flex;
  flex-direction: column;
}

.qw-basket__price-total--converted {
  width: 100%;
  text-align: right;
  margin-top: 12px;
}

.qw-basket__price qw-loading {
  margin-left: var(--qw-hotel-gap-sm);
}

.qw-basket__price .qw-basket__price__amount--disabled {
  opacity: var(--qw-hotel-opacity);
}

.qw-basket__price-total {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-end;
}

@media only screen and (max-width: 738px) {
  qw-basket {
    margin: 22px 20px 0;
    padding: 22px 0 0;
  }
  qw-basket .qw-basket__price {
    align-items: flex-start;
  }
  qw-basket .qw-basket__price span,
  qw-basket .qw-basket__price .qw-basket__price-total {
    font-size: 20px;
  }
  qw-basket .qw-basket__price-total--converted {
    font-size: 16px;
  }
  qw-basket .qw-basket__price + .qw-basket__on-site-tax-total {
    padding: 4px 0 0;
  }
  .qw-basket__price-total {
    align-items: flex-end;
  }
}
